<script lang="ts">
  import ConfirmationModal from '~/components/modals/confirmationModal.vue';
  import SelectedMixin from "../mixins/selectedMixin";
  import ObjectModelEntry from "~/models/objectModelEntries/objectModelEntry";
  import CreateNoteMixin from "~/mixins/createNoteMixin";
  import NoteEditor from "../../../common/components/notes/note-editor.vue";

  export default ConfirmationModal.extend({
    mixins: [
        SelectedMixin,
        CreateNoteMixin,
    ],
    components: {NoteEditor},
    props: {
      entry: {
        type: Object as () => ObjectModelEntry,
        required: true,
      },
      actionTitle: {
        type: String,
        required: true,
      },
      noteRequired: {
        type: Boolean,
        required: true,
      },
      context: {
        type: Number,
        required: true
      }
    },
    mounted() {
      if (this.noteRequired) {
        this.newNote.author_id = this.selectedUser.id;
        this.newNote.entry_id = this.entry.id;
        this.newNote.action_title = this.actionTitle;
        if (this.selectedDetailView) {
          this.newNote.detail_view_id = this.selectedDetailView.detail_view_id;
        } else if (this.selectedListView) {
          this.newNote.list_view_id = this.selectedListView.id;
        } else {
          throw new Error('Cannot create note from modal, no selected content view found.');
        }
      }
    },
    computed: {
      disableAffirm(): boolean {
        return this.noteRequired && (this.isPosting || this.newNote.text.trim().length === 0);
      },
      // for createNoteMixin +add+ method
      objectModelEntry() {
        return this.entry
      }
    },
    methods: {
      affirmAction(data): void {
        if (this.noteRequired) this.add();
        this.emitHideModal(data);
      },
    },
  });
</script>

<template>
  <modal :state="state" :index="index" @toggle-modal="emitHideModal">
    <div slot="body">
      <h3 class="modal-title">{{details.confirmationHeader}}</h3>
      <p v-if="details.htmlSafeConfirmationMessage" v-html="details.htmlSafeConfirmationMessage"></p>

      <div v-if="noteRequired" class="align-left mt-3 new-comms-area">
        <label for="required-note" class="required ">Please include a note to explain this action.</label>
        <note-editor
          refs="note-editor"
          v-model="newNote.text"
          id="required-note"
          placeholder="Write your note here..."
        ></note-editor>
      </div>

      <div class="cta">
        <button v-if="details.showCancel" type="button" @click="emitHideModal" :class="buttonClass('cancel')" data-action="cancel">{{details.cancelText}}</button>
        <button v-if="details.showAffirm"
                type="button"
                @click="affirmAction"
                :class="buttonClass('affirm')"
                :disabled="disableAffirm"
                data-action="affirm">
          {{ details.affirmText }}
        </button>
      </div>
    </div>
  </modal>
</template>
